export default "__VITE_ASSET__BkW9ZahJ__"